import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

type GetDocumentSignaturePdfsParams = {
  companyId: number
  page?: number
  pageSize?: number
}

export type DocumentSignaturePdf = {
  id: number
  path: string
  type: string
  tempUrl: string
  extra: Record<string, unknown>
}

type GetDocumentSignaturePdfsResponse = {
  files: DocumentSignaturePdf[]
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export async function getDocumentSignaturePdfs({
  companyId,
  page = 0,
  pageSize = 50,
}: GetDocumentSignaturePdfsParams) {
  const response = await api.get<GetDocumentSignaturePdfsResponse>(
    `/admin/company/${companyId}/files`,
    {
      params: {
        page,
        page_size: pageSize,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return response.data
}
